import { head, range } from 'ramda'
import { parse } from '@datasert/cronjs-parser'
import React from 'react'

import { changeCronValue } from './_helpers/cron'
import { useForm, useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../EditableSentence'
import Text from '../../../../../packages/kiti/components/presentation/Text'

const TIMES = range(0, 24).reduce(
  (options, h) => [...options, ...range(0, 4).map(m => `${String(h).padStart(2, '0')}:${m * 15 || '00'}`)],
  []
)

const TimeSentence = () => {
  const form = useForm()
  const { handleChange } = useFormState()
  const frequency = head(parse(form.frequency || '* * * * *')?.expressions)

  const timeValue =
    frequency?.hour?.values &&
    String(head(frequency?.hour?.values || [])).padStart(2, '0') +
      ':' +
      String(head(frequency?.minute?.values || [])).padStart(2, '0')

  const handleChangeTime = time => {
    const [hour, minute] = time.split(':')
    handleChange('frequency', changeCronValue(frequency, 'time', { hour, minute }))
  }

  return (
    <>
      <Text size="h2"> as </Text>
      <EditableSentence
        label={timeValue || '_____'}
        field="time"
        value={timeValue}
        onChange={handleChangeTime}
        options={TIMES}
        truncate={15}
        width={10}
      />
    </>
  )
}

export default TimeSentence
